import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

export const FulfilmentPodPlaceholder = () => (
  <div>
    <Placeholder type="text" />
    <Placeholder type="text" />
  </div>
);
